import {Component, forwardRef, Injector, Input} from "@angular/core";
import {AbstractEditControlComponent} from "../../../entity/edit/edit-controls/abstract-edit-control.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CurrencyEditControlComponent),
    multi: true
};

/**
 * Currency edit for fields such as price and cost
 */
@Component({
    selector: "wbo-currency-edit-control",
    templateUrl: "./currency-edit-control.component.html",
    providers: [CUSTOM_VALUE_ACCESSOR]
})
export class CurrencyEditControlComponent extends AbstractEditControlComponent {

    /**
     * Number of decimal places
     */
    @Input() public decimalPlaces: number = 2;

    constructor(injector: Injector) {
        super(injector);
    }
}
